<template>
	<section>
		main
	</section>
</template>

<script>
  export default {
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Main.vue?f2a9927c